module.exports = __webpack_public_path__ + "static/img/3-info-b3-img1.2278c4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3-info-b3-img1.png
// module id = JRP5
// module chunks = 0